import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type CountryLanguageKey = {
  idCountry: number;
  idLanguage: number;
};

// Базовый тип для create/update операций страны-языка
type CountryLanguageCreateUpdateData = CountryLanguageKey & {
  name: string;
};

// Типы для WebSocket сообщений компонента countryLanguages
type CountryLanguagesListMessage = WebSocketMessageWithFields<'language-country-name' | 'language-locale-list', {
  countryLanguages: unknown[];
}>;
type CountryLanguageCreateMessage = WebSocketMessageWithFields<'language-country-name-create' | 'language-country-name-create-success', CountryLanguageCreateUpdateData>;
type CountryLanguageUpdateMessage = WebSocketMessageWithFields<'language-country-name-update' | 'language-country-name-update-success', CountryLanguageCreateUpdateData>;
type CountryLanguageDeleteMessage = WebSocketMessageWithFields<'language-country-name-delete' | 'language-country-name-delete-success', CountryLanguageKey>;
type CountryLanguageLockMessage = WebSocketMessageWithFields<'language-country-name-lock' | 'language-country-name-lock-success', CountryLanguageKey>;
type CountryLanguageUnlockMessage = WebSocketMessageWithFields<'language-country-name-unlock' | 'language-country-name-unlock-success', CountryLanguageKey>;

// Объединенный тип для всех сообщений
type CountryLanguagesWebSocketMessage = 
  | CountryLanguagesListMessage 
  | CountryLanguageCreateMessage 
  | CountryLanguageUpdateMessage 
  | CountryLanguageDeleteMessage 
  | CountryLanguageLockMessage 
  | CountryLanguageUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  __name: 'countryLanguages',
  setup(__props) {

const store = useStore<RootState>();

// Базовый тип для сообщений с составным ключом страны и языка
const handleWebSocketMessage = (data: CountryLanguagesWebSocketMessage): void => {
  if (!data?.signal) return;
  switch (data.signal) {
    case 'language-country-name':
    case 'language-locale-list':
      store.dispatch('countryLanguages/wsCountryLanguages', { countryLanguages: data.countryLanguages });
      break;
    case 'language-country-name-create':
    case 'language-country-name-create-success':
      store.dispatch('countryLanguages/wsCountryLanguagesCreate', {
        idCountry: data.idCountry,
        idLanguage: data.idLanguage,
        name: data.name,
      });
      break;
    case 'language-country-name-update':
    case 'language-country-name-update-success':
      store.dispatch('countryLanguages/wsCountryLanguagesUpdate', {
        idCountry: data.idCountry,
        idLanguage: data.idLanguage,
        name: data.name,
      });
      break;
    case 'language-country-name-delete':
    case 'language-country-name-delete-success':
      store.dispatch('countryLanguages/wsCountryLanguagesDelete', {
        idCountry: data.idCountry,
        idLanguage: data.idLanguage,
      });
      break;
    case 'language-country-name-lock':
    case 'language-country-name-lock-success':
      store.dispatch('countryLanguages/wsCountryLanguagesLock', {
        idCountry: data.idCountry,
        idLanguage: data.idLanguage,
      });
      break;
    case 'language-country-name-unlock':
    case 'language-country-name-unlock-success':
      store.dispatch('countryLanguages/wsCountryLanguagesUnlock', {
        idCountry: data.idCountry,
        idLanguage: data.idLanguage,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})